import React from 'react';
import styled from 'styled-components';
// ANTD
import Select from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const { Option } = Select;

const LONG_ICON_OPTIIONS = [
  {
    id: '1',
    label: 'circle_quarterly_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883625/cclariti/circle_quarterly_icon.svg',
  },
  {
    id: '2',
    label: 'circle_bpci_opportunity_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883624/cclariti/circle_bpci_opportunity_icon.svg',
  },
  {
    id: '3',
    label: 'circle_provider_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/circle_provider_icon.svg',
  },
  {
    id: '4',
    label: 'circle_bpci_performance_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/circle_bpci_performance_icon.svg',
  },
  {
    id: '5',
    label: 'circle_pac_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/circle_pac_icon.svg',
  },
  {
    id: '6',
    label: 'circle_quarterly_icon.svg',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883625/cclariti/circle_quarterly_icon.svg',
  },
  // PNG
  {
    id: '7',
    label: 'Icon_Custom_Reports.png',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/Custom_Reports.svg',
  },
  {
    id: '8',
    label: 'Icon_Market_Mapper.png',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883620/cclariti/Market_Mapper_icon.svg',
  },
  {
    id: '9',
    label: 'Icons_Claims_Insights.png',
    url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883622/cclariti/Claims_Insights_icon.svg',
  },
];

const OptionContent = styled.div`
  width: 100%;
  margin: 2px;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start;
`;

const StyleWrapper = styled.div`
  .ant-select-selection,
  .ant-select-selection__rendered,
  .ant-select-selection-selected-value {
    height: 60px !important;
  }
  .ant-select-selection-selected-value {
    display: flex !important;
    align-items: center !important;
  }
`;

// EXPORTED COMPONENT
// ================================================================
const DashboardIconInput = props => {
  const { onChange, value } = props;

  return (
    <StyleWrapper>
      <Select value={value} onChange={onChange} size="large" style={{ width: 295, height: 60, margin: 8 }}>
        {LONG_ICON_OPTIIONS.map(icon => (
          <Option key={icon.id} value={icon.url}>
            <OptionContent>
              <img src={icon.url} alt="dashboard-icon" height="60" />
              {icon.label}
            </OptionContent>
          </Option>
        ))}
      </Select>
    </StyleWrapper>
  );
};

// EXPORT
// ================================================================
export default DashboardIconInput;



// WEBPACK FOOTER //
// ./src/components/inputs/DashboardIconInput/index.js